const en: Record<string, string> = {
  'features.language.code.fr': 'French',
  'features.language.code.en': 'English',
  'features.language.code.de': 'German',

  'features.language.wordType.noun': 'Noun',
  'features.language.wordType.adjective': 'Adjective',
  'features.language.wordType.verb': 'Verb',

  'features.language.setupTitle': 'Set up this project\'s language pair',
  'features.language.setupHelp': 'Pick the language you already know and the one you want to learn. This can only be set once.',
  'features.language.sourceLanguage': 'I speak',
  'features.language.targetLanguage': 'I want to learn',
  'features.language.setupSubmit': 'Save language pair',

  'features.language.newLesson': 'New lesson',
  'features.language.lessonTitle': 'Lesson title',
  'features.language.lessonTitlePlaceholder': 'e.g. Greetings',
  'features.language.cancel': 'Cancel',
  'features.language.create': 'Create',

  'features.language.noLessons': 'No lessons yet. Add one to get started.',
  'features.language.wordCount': '{{count}} words',
  'features.language.removeWordFromLesson': 'Remove from lesson',
  'features.language.removeWordFromLessonConfirm': 'This word will no longer be part of this lesson. It is not deleted: it stays available in the shared dictionary.',
  'features.language.subTabLesson': 'The lesson',
  'features.language.subTabVocabulary': 'The vocabulary',
  'features.language.backToLessons': 'Back to lessons',
  'features.language.words': 'Words',
  'features.language.noWords': 'No words in this lesson yet.',
  'features.language.addWord': 'Add word',
  'features.language.addWordTitleGerman': 'Add a word in German',

  'features.language.article': 'Article',
  'features.language.plural': 'Plural',
  'features.language.translatePlural': 'Translate the plural',
  'features.language.declensions': 'Declensions',
  'features.language.declensionCase': 'Case',
  'features.language.declensionForm': 'Form',
  'features.language.addDeclension': 'Add declension',
  'features.language.removeDeclension': 'Remove declension',

  'features.language.wordText': 'Word',
  'features.language.wordTypeLabel': 'Type',
  'features.language.changeWord': 'Change',
  'features.language.suggestTranslation': 'Suggest',
  'features.language.noSuggestionFound': 'No suggestion found.',
  'features.language.searchOnline': 'Search online',
  'features.language.searchOnlineTooltip': 'Search online, do not overuse',
  'features.language.searchOnlineHint': 'The word you typed will be sent to an online translation service (DeepL).',
  'features.language.onlineSuggestionNotice': 'Automatic translation: check the article, the plural and the type.',
  'features.language.lessonWordsHintLabel': 'In the lessons',
  'features.language.dictionaryHintLabel': 'In the dictionary',
  'features.language.searchWordPlaceholder': 'Search or type a new word…',
  'features.language.noMatchingWord': 'No matching word — keep typing to create a new one.',
  'features.language.reusedWordOptionalTranslationHint': 'This word already exists. You can optionally link a translation to it, or leave it blank.',
  'features.language.addWordError': 'Could not add this word.',
  'features.language.wordAddedKeepAdding': 'Word added. You can add another one.',
  'features.language.backToLesson': 'Back to lesson',
  'features.language.editWord': 'Edit word',
  'features.language.saveChanges': 'Save changes',
  'features.language.updateWordError': 'Could not save these changes.',

  'features.language.exportPdf': 'Download PDF',

  'features.language.configureColors': 'Configure language colors',
  'features.language.colorsPreview': 'Preview',

  'features.language.choiceMode': 'Pick from choices',
  'features.language.submitAnswer': 'Submit',
  'features.language.correct': 'Correct!',
  'features.language.incorrect0': 'Not quite.',
  'features.language.incorrect1': 'Almost!',
  'features.language.incorrect2': 'Missed, but you\'ll get there.',
  'features.language.incorrect3': 'That\'s not it.',
  'features.language.incorrect4': 'Ouch, not this time.',
  'features.language.incorrect5': 'No, but keep going!',
  'features.language.incorrect6': 'Nope, give it another try.',
  'features.language.incorrect7': 'Not yet.',
  'features.language.incorrect8': 'Too bad, the next one will be right.',
  'features.language.incorrect9': 'That wasn\'t the right answer.',
  'features.language.correctAnswerWas': 'Correct answer: {{answer}}',
  'features.language.wordScorePercent': 'Word mastery: {{percent}}%',
  'features.language.continue': 'Continue',
  'features.language.overallScorePercent': 'Score: {{percent}}%',
  'features.language.testTabDirection': 'Test {{from}} → {{to}}',
  'features.language.testTabRandom': 'Random test',
  'features.language.testTabResults': 'Results',
  'features.language.wordCounter': 'Word {{current}} / {{total}}',
  'features.language.restartFullTest': 'Start over',
  'features.language.resultsPerson': 'Person',
  'features.language.noAttemptsYet': 'No answer yet',
  'features.language.testMode.free': 'Free',
  'features.language.testMode.choice': 'Choice',
  'features.language.testTabArticles': 'Article test',
  'features.language.articleQuestion': 'Which article goes with this noun?',
  'features.language.noArticleWords': 'No noun with an article in this lesson yet.',
  'features.language.scoreOverTime': 'Score over time',
  'features.language.noChartData': 'No answer in this period.',
  'features.language.chartPeriod.week': '1 week',
  'features.language.chartPeriod.month': '1 month',
  'features.language.chartPeriod.threeMonths': '3 months',
  'features.language.chartPeriod.all': 'All',
  'features.language.testTabPlurals': 'Plural test',
  'features.language.pluralQuestion': 'Type the plural of this noun',
  'features.language.noPluralWords': 'No noun with a plural in this lesson yet.',
  'features.language.scoreExplanationTitle': 'How is the result calculated?',
  'features.language.scoreExplanationOverall': 'The big score is the average of the scores of all the words in the lesson, for the selected person. The chart shows how it evolved day by day.',
  'features.language.scoreExplanationPoints': 'Each word is worth points: 6 for each translation direction (known language to learned language, and back), plus 3 for the article and 3 for the plural when the learned-language noun has them. A verb or an adjective is out of 12, a noun out of 15 or 18. The word\'s score is the points earned over the points possible.',
  'features.language.scoreExplanationDays': 'A part earns its points over 3 different days of correct answers: answering correctly several times on the same day counts once, and a part never earns more than its maximum.',
  'features.language.scoreExplanationChoice': 'Picking the translation among choices counts for only a fifth of a day, much less than typing it. Article and plural answers count fully.',
  'features.language.scoreExplanationDecay': 'A word that has not been tested for a full week loses 10% of its score, and again for each further week, until you practice it again.',
  'features.language.reviewComplete': 'You\'ve reviewed every word in this lesson.',
  'features.language.noTestableWords': 'None of this lesson\'s words have a translation yet.',
};

export default en;
